module.exports = __webpack_public_path__ + "static/media/ic-seta-direita.7c434d4b.svg";